<template>
  <div class="pagemain">
    <menu2 v-if="project_name" style="z-index: 999" :page_name="project_name+'-项目介绍（项目单）'" back_type="close" back_icon="md-close"></menu2>
    <div style="height:40px;"></div>
    <!-- <div class="page_title">
      
      <span>
        {{ project_name }} - 项目介绍（项目单）
      </span>
    </div> -->

    <div class="page_content">
      <div class="">
        <div class="card1">
          <div class="card_title">公司详情</div>

          <div class="input_div">
            <div class="input_title">客户公司名称：</div>

            <div class="input_value">
              <div>
                {{ update_data.company_name ? update_data.company_name : "--" }}
              </div>
            </div>
          </div>

          <div class="input_div">
            <div class="input_title">客户公司简介：</div>

            <div class="input_value">
         
                {{ update_data.company_profile ? update_data.company_profile : "--" }}
            
            </div>
          </div>

          <div class="input_div">
            <div class="input_title">项目照片：</div>
            <div>
              <div class="img_div2">
                <div v-for="(item, i) in img_list" :key="i" class="imgdiv3">
                  <!-- <div class="close_img" @click="close_img(item)">
                  <Icon type="md-close" color="#fff" />
                </div> -->
                  <div class="img_div" @click="view_img(item.url)">
                    <img :src="item.url" alt=""  style="height: 100%;width: 100%; " />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="input_div">
            <div class="input_title">项目视频：</div>
            <div>
              <div class="img_div2">
                <div v-for="(item, i) in video_list" :key="i" class="imgdiv3">
                  <div class="img_div" @click="view_video(item.url)">
                    <video :src="item.url" alt="" style="height: 100%; height: 100%" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div></div>
        </div>
      </div>

      <!--  -->

      <div class="card1">
        <div class="card_title">项目信息</div>

        <div class="input_div">
          <div class="input_title">工作环境：</div>

          <div class="input_value">
            {{ update_data.work_environment ? update_data.work_environment : "--" }}
          </div>
        </div>

        <div class="input_div">
          <div class="input_title">用工性质：</div>

          <div class="input_value">
            {{ update_data.work_type ? update_data.work_type : "--" }}
          </div>
        </div>

        <div class="input_div">
          <div class="input_title">用工特殊说明：</div>

          <div class="input_value">
            {{
              update_data.work_special_instructions
                ? update_data.work_special_instructions
                : "--"
            }}
          </div>
        </div>

        <div class="input_div">
          <div class="input_title">招聘岗位：</div>

          <div class="input_value">
            {{
              update_data.recruitment_position ? update_data.recruitment_position : "--"
            }}
          </div>
        </div>

        <div class="input_div">
          <div class="input_title">工服说明：</div>

          <div class="input_value">
            {{ update_data.work_uniform ? update_data.work_uniform : "--" }}
          </div>
        </div>

        <div class="input_div">
          <div class="input_title">工种说明：</div>

          <div class="input_value">
            {{ update_data.work_type_desc ? update_data.work_type_desc : "--" }}
          </div>
        </div>

        <div class="input_div">
          <div class="input_title">工时说明：</div>

          <div class="input_value">
            {{ update_data.man_hour_desc ? update_data.man_hour_desc : "--" }}
          </div>
        </div>

        <div class="input_div">
          <div class="input_title">就餐：</div>

          <div class="input_value">
            {{ update_data.repast_desc ? update_data.repast_desc : "--" }}
          </div>
        </div>

        <div class="input_div">
          <div class="input_title">住宿：</div>

          <div class="input_value">
            {{ update_data.dormitory_desc ? update_data.dormitory_desc : "--" }}
          </div>
        </div>
      </div>

      <div class="card1">
        <div class="card_title">薪资介绍</div>

        <div class="input_div">
          <div class="input_title">安心保承诺薪资：</div>

          <div class="input_value">
            {{ update_data.promised_salary ? update_data.promised_salary : "--" }}
          </div>
        </div>

        <div class="input_div">
          <div class="input_title">薪资属性/构成：</div>

          <div class="input_value">
            {{ update_data.salary_structure ? update_data.salary_structure : "--" }}
          </div>
        </div>

        <div class="input_div">
          <div class="input_title">薪酬：</div>

          <div class="input_value">
            {{ update_data.salary_desc ? update_data.salary_desc : "--" }}
          </div>
        </div>

        <div class="input_div">
          <div class="input_title">其他和钱相关补贴：</div>

          <div class="input_value">
            {{ update_data.other_subsidies ? update_data.other_subsidies : "--" }}
          </div>
        </div>

        <div class="input_div">
          <div class="input_title">发薪日/发放说明：</div>

          <div class="input_value">
            {{ update_data.pay_day ? update_data.pay_day : "--" }}
          </div>
        </div>

        <div class="input_div">
          <div class="input_title">工资/生活费预支：</div>

          <div class="input_value">
            {{ update_data.prepay_wage ? update_data.prepay_wage : "--" }}
          </div>
        </div>

        <div class="input_div">
          <div class="input_title">银行黑户：</div>

          <div class="input_value">
            {{ update_data.bank_black ? update_data.bank_black : "--" }}
          </div>
        </div>

        <div class="input_div">
          <div class="input_title">银行卡要求：</div>

          <div class="input_value">
            {{ update_data.bank_card ? update_data.bank_card : "--" }}
          </div>
        </div>
      </div>

      <div class="card1">
        <div class="card_title">保险</div>

        <div class="input_div">
          <div class="input_title">合同说明：</div>

          <div class="input_value">
            {{ update_data.contract_desc ? update_data.contract_desc : "--" }}
          </div>
        </div>

        <div class="input_div">
          <div class="input_title">用工关系：</div>

          <div class="input_value">
            {{ update_data.work_relation ? update_data.work_relation : "--" }}
          </div>
        </div>

        <div class="input_div">
          <div class="input_title">保险说明：</div>

          <div class="input_value">
            {{ update_data.insurance_desc ? update_data.insurance_desc : "--" }}
          </div>
        </div>
      </div>

      <div class="card1">
        <div class="card_title">录用条件</div>

        <div class="input_div">
          <div class="input_title">性别/年龄要求：</div>

          <div class="input_value">
            {{ update_data.age_gender_desc ? update_data.age_gender_desc : "--" }}
          </div>
        </div>

        <div class="input_div">
          <div class="input_title">民族/户籍要求：</div>

          <div class="input_value">
            {{ update_data.nation_hukou_desc ? update_data.nation_hukou_desc : "--" }}
          </div>
        </div>

        <div class="input_div">
          <div class="input_title">证件/学历/经验要求：</div>

          <div class="input_value">
            {{ update_data.experience_desc ? update_data.experience_desc : "--" }}
          </div>
        </div>

        <div class="input_div">
          <div class="input_title">体检说明：</div>

          <div class="input_value">
            {{ update_data.health_examination ? update_data.health_examination : "--" }}
          </div>
        </div>

        <div class="input_div">
          <div class="input_title">其他硬性要求：</div>

          <div class="input_value">
            {{ update_data.other_requirements ? update_data.other_requirements : "--" }}
          </div>
        </div>
      </div>

      <div class="card1">
        <div class="card_title">面试及入职流程</div>

        <div class="input_div">
          <div class="input_title">工作/面试地点：</div>

          <div class="input_value">
            {{ update_data.interview_location ? update_data.interview_location : "--" }}
          </div>
        </div>

        <div class="input_div">
          <div class="input_title">面试携带/着装要求：</div>

          <div class="input_value">
            {{
              update_data.interview_requirements
                ? update_data.interview_requirements
                : "--"
            }}
          </div>
        </div>

        <div class="input_div">
          <div class="input_title">面试时间：</div>

          <div class="input_value">
            {{ update_data.interview_time ? update_data.interview_time : "--" }}
          </div>
        </div>

        <div class="input_div">
          <div class="input_title">面试/入职流程：</div>

          <div class="input_value">
            {{ update_data.interview_flow ? update_data.interview_flow : "--" }}
          </div>
        </div>

        <div class="input_div">
          <div class="input_title">入职材料/通知模板：</div>

          <div class="input_value">
            {{ update_data.induction_materials ? update_data.induction_materials : "--" }}
          </div>
        </div>

        <div class="input_div">
          <div class="input_title">入职费用：</div>

          <div class="input_value">
            {{ update_data.entry_fee ? update_data.entry_fee : "--" }}
          </div>
        </div>

        <div class="input_div">
          <div class="input_title">离职说明：</div>

          <div class="input_value">
            {{ update_data.dimission_desc ? update_data.dimission_desc : "--" }}
          </div>
        </div>

        <div class="input_div">
          <div class="input_title">职位JD：</div>

          <div class="input_value">
            {{ update_data.jd ? update_data.jd : "--" }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { http, open_new_page } from "@/utils/http.js";
import menu2 from "@/component/menu/menu2.vue";

export default {
  components: {
    menu2,

  },
  data() {
    return {
      img_upload:
        process.env.VUE_APP_HOST +
        "/my_project/upload_introduction_img?token=" +
        this.$cookies.get("dx_token"),

      mp4_upload:
        process.env.VUE_APP_HOST +
        "/my_project/upload_introduction_video?token=" +
        this.$cookies.get("dx_token"),

      project_name: "",
      project_id: "",

      img_list: [],
      video_list: [],

      update_data: {
        company_name: "",
        company_profile: "",
        work_environment: "",
        work_type: "",
        work_special_instructions: "",
        recruitment_position: "",
        work_uniform: "",
        work_type_desc: "",
        man_hour_desc: "",
        repast_desc: "",
        dormitory_desc: "",
        promised_salary: "",
        salary_structure: "",
        salary_desc: "",
        other_subsidies: "",
        pay_day: "",
        prepay_wage: "",
        bank_black: "",
        bank_card: "",
        contract_desc: "",
        work_relation: "",
        insurance_desc: "",
        age_gender_desc: "",
        nation_hukou_desc: "",
        experience_desc: "",
        health_examination: "",
        other_requirements: "",
        interview_location: "",
        interview_requirements: "",
        interview_time: "",
        interview_flow: "",
        induction_materials: "",
        entry_fee: "",
        dimission_desc: "",
        jd: "",
      },
    };
  },
  mounted() {
    var query = this.$route.query;
    console.log(query);
    if (query.project_id) {
      this.project_id = query.project_id;
    }
    this.get_projectd_introduction_data();
  },

  methods: {
    img_success(e) {
      console.log(e);
      if (e.code == 0) {
        this.$refs.upload_img.clearFiles();
        this.$refs.upload_video.clearFiles();
        this.get_projectd_introduction_data();
      } else {
        this.$refs.upload_img.clearFiles();
        this.$refs.upload_video.clearFiles();
        this.$Message.error(e.msg);
      }
    },

    bank_home() {
      open_new_page("/");
    },

    input_blur_change(key, value) {
      console.log(key, value);
      this.update_value(key, value);
    },

    //更新数据
    update_value(key, value) {
      var that = this;
      var obj = {
        project_id: this.project_id,
        key: key,
        value: value,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/project_introduction_update",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //获取数据
    get_projectd_introduction_data() {
      var that = this;
      var obj = {
        project_id: this.project_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/project_introduction_info",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.update_data = res.data.detail_info;
            that.project_name = res.data.project_name;
            that.img_list = res.data.image_list;
            that.video_list = res.data.video_list;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //删除媒体
    del_file(id, type) {
      var that = this;
      var obj = {
        file_id: id,
        file_type: type,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/my_project/del_introduction_imgage",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_projectd_introduction_data();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    view_img(url) {
      console.log(11111);
      this.$ImagePreview.show({
        previewList: [url],
      });
    },

    view_video(url) {
      console.log(11111);
      open_new_page(url);
    },

    close_img(item) {
      var that = this;
      this.$Modal.confirm({
        title: "提示",
        content: "<p>是否要删除这个图片？</p>",
        onOk: () => {
          that.del_file(item.id, "img");
        },
        onCancel: () => {},
      });
    },

    close_video(item) {
      var that = this;
      this.$Modal.confirm({
        title: "提示",
        content: "<p>是否要删除这个视频？</p>",
        onOk: () => {
          that.del_file(item.id, "video");
        },
        onCancel: () => {},
      });
    },
  },
};
</script>

<style scoped>

.page_content{
    height:calc(100vh - 40px);
    padding-bottom: 10px;;
    overflow: auto;
}


.img_div2 {
  display: flex;
  align-items: center;
}

.close_img {
    z-index: 99;
  position: absolute;
  width: 15px;
  height: 15px;
  background: rgb(251, 144, 144);
  right: 10px;
  top: 0px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.close_img:hover {
  background: red;
}

.imgdiv3 {
  position: relative;
}

.card_title {
  background: #0b7ecb;
  color: #fff;
  text-align: center;
  width: 120px;
  position: absolute;
  border-radius: 0 0 10px 0;
  font-size: 13px;
  padding: 5px 0;
  top: 0;
  left: 0;
}

.img_div {
  height: 60px;
  width: 60px;
  margin-bottom: 10px;
  margin-right: 10px;
  border-radius: 5px;
  overflow: hidden;
}

.img_div:hover {
  cursor: pointer;
  border:1px solid #0466dd;
  box-shadow: 0 0 3px #ccc;
}

.pagemain {
  background: #ececec;
}

.input_value {
  width: 100%;
  font-size: 13px;
  color: #333;
  white-space: pre-wrap;

}

.card1 {
  background: #fff;
  margin: 10px;
  border-radius: 5px;
  overflow: hidden;
  padding: 35px 20px 10px 20px;
  position: relative;
}

.input_title {
  width: 170px;
  flex-shrink: 0;
  font-size: 14px;
  padding-top: 3px;
}

.input_tishi {
  font-size: 12px;
  color: #c9b6b6;
  padding: 3px 0 0 5px;
}

.input_div {
  display: flex;
  align-items: flex-start;
  margin-bottom: 10px;
}

.back_home {
  color: #e2e9f1;
  cursor: pointer;
  margin-right: 10px;
}

.back_home:hover {
  color: #fff;
}

.page_title {
  font-weight: 300;
  display: flex;
  align-items: center;
  justify-content: space-between;
  letter-spacing: 3px;
  padding: 0 15px 0 15px;
  background-color: #0466dd;
  color: #fff;
  height: 40px;
  line-height: 40px;
}
</style>
